// extracted by mini-css-extract-plugin
export default {"scrollContainer":"ii3Ke","wrapper":"pRtNl","tariffCard":"hB7M5","specTariff":"Qv5RE"};